import { toResponseError, type CanvassGenerateInput, type CanvassGenerateSuccess } from '@terros/common'
import { mutationAdd, type AddHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'

export function useGenerateCanvassDemo(): AddHookResponse<CanvassGenerateInput, CanvassGenerateSuccess> {
  const mutation = useTantalimMutation<CanvassGenerateInput, CanvassGenerateSuccess>({
    url: '/canvass/demo/generate',
  })

  async function generate(input: CanvassGenerateInput): Promise<CanvassGenerateSuccess> {
    try {
      const result = await mutation.mutateAsync(input)
      return result
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, generate)
}
